"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SilentTokenRenew = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emitter = require("skybase-ui/skybase-core/emitter");

var _oauth = require("../oauth");

var _constants = require("../constants");

var _utils = require("../permission-sets/utils");

var _utils2 = require("../permissions/utils");

var _actions = require("./actions");

var _constants2 = require("./constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var _SilentTokenRenew = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(_SilentTokenRenew, _Component);

  var _super = _createSuper(_SilentTokenRenew);

  function _SilentTokenRenew(props) {
    var _this;

    (0, _classCallCheck2.default)(this, _SilentTokenRenew);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTriggerSilentRenew", function () {
      _oauth.OAuth.oAuthService.invalidateSession();

      _this.handleCheckToken();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "willTokenExpire", function () {
      var token = _oauth.OAuth.oAuthHandler.getAccessToken();

      var threshold = 300; // 300s = 5 minute threshold for token expiration

      var hasToken = token && token.decodedAccessToken;
      var now = Date.now() / 1000 + threshold;
      return !hasToken || now > token.decodedAccessToken.exp;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCheckToken", function () {
      if (_this.willTokenExpire()) {
        _this.setState({
          renewing: true
        });

        clearInterval(_this.timeInterval);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSetPermissions", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, setUserData, handleFetchPermissions, permissionSetIds, permissions;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, setUserData = _this$props.setUserData, handleFetchPermissions = _this$props.handleFetchPermissions;
              permissionSetIds = _oauth.OAuth.oAuthHandler.getAccessToken().decodedAccessToken.permission_set;
              _context.next = 4;
              return (0, _utils.fetchPermissionSets)(permissionSetIds);

            case 4:
              permissions = _context.sent;
              handleFetchPermissions();
              setUserData({
                permissionSetIds: permissionSetIds,
                permissions: permissions
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "silentRenew", function () {
      return new Promise(function (resolve, reject) {
        var checkRedirect = function checkRedirect() {
          var redirectUrl = window.localStorage[_constants.SKYBASE_AUTH_SILENT_REDIRECT_KEY];

          if (!redirectUrl) {
            _this.currentAttempt += 1;

            if (_this.currentAttempt > _this.maxNumberOfAttempts) {
              reject({
                message: 'SkyBase OAuth 2: Silent renew failed after maximum number of attempts.',
                short: 'max_number_of_attempts_reached'
              });
              return;
            }

            _this.timeout = setTimeout(function () {
              return checkRedirect();
            }, 500);
            return;
          } // we have set the redirect, so lets work with it


          window.localStorage.removeItem(_constants.SKYBASE_AUTH_SILENT_REDIRECT_KEY); // Silent renew didn't work as expected, or some error happened
          // before it finished

          if (typeof redirectUrl !== 'string' || redirectUrl.length === 0) {
            reject({
              message: 'SkyBase OAuth 2: Silent renew didnt work.',
              short: 'silent_renew_didnt_work'
            });
            return;
          } // Window was closed, and reached the redirect.html; however there still
          // might have been error during authentication, check url


          var error = _oauth.OAuth.oAuthService.extractError(redirectUrl, true);

          if (error) {
            var errorReason = error.errorReason,
                errorDescription = error.errorDescription;
            reject({
              message: "SkyBase OAuth 2: Error during login. Reason: ".concat(errorReason, " Description: ").concat(errorDescription),
              short: errorReason
            });
            return;
          } // Silent renew work as expected, lets update the access token


          var session = _oauth.OAuth.oAuthService.extractSession(redirectUrl);

          sessionStorage.setItem(_constants2.SESSION_KEY, JSON.stringify(session)); // Set new permissions for the current user

          _this.handleSetPermissions();

          resolve(session);
        };

        checkRedirect();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnLoad", function () {
      _this.silentRenew().then(function () {
        _this.setState({
          renewing: false
        });

        _this.currentAttempt = 0;
        _this.timeInterval = setInterval(_this.handleCheckToken, 60000);

        _emitter.SbEmitter.emit('oauth.success.silent_renew', 'SkyBase OAuth 2: Access token renewed silently.');
      }).catch(function (error) {
        var short = error.short,
            message = error.message;

        _this.setState({
          renewing: false
        });

        _emitter.SbEmitter.emit("oauth.error.".concat(short), message);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderIframe", function () {
      var url = new URL(_oauth.OAuth.oAuthService.getAuthorizeUrl());
      url.searchParams.set('redirect_uri', _oauth.OAuth.config.SILENT_RENEW_REDIRECT_URI || _constants2.DEFAULT_SILENT_RENEW_REDIRECT_URI);
      url.searchParams.set('prompt', 'none');
      return /*#__PURE__*/_react.default.createElement("iframe", {
        style: {
          width: 0,
          height: 0,
          position: 'absolute',
          left: 0,
          top: 0,
          display: 'none',
          visibility: 'hidden'
        },
        width: 0,
        height: 0,
        title: "silent-token-renew",
        src: url.href,
        onLoad: _this.handleOnLoad
      });
    });
    _this.state = {
      renewing: false
    };
    _this.currentAttempt = 0;
    _this.maxNumberOfAttempts = 20;
    _this.timeout = null;
    _this.timeInterval = null;
    return _this;
  }

  (0, _createClass2.default)(_SilentTokenRenew, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.renewing !== nextState.renewing; // eslint-disable-line
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.timeInterval = setInterval(this.handleCheckToken, 20000);

      _emitter.SbEmitter.on('oAuth.TriggerSilentRenew', this.handleTriggerSilentRenew);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.timeInterval);
      clearTimeout(this.timeout);

      _emitter.SbEmitter.off('oAuth.TriggerSilentRenew', this.handleTriggerSilentRenew);
    }
  }, {
    key: "render",
    value: function render() {
      var renewing = this.state.renewing;
      return renewing ? this.renderIframe() : null;
    }
  }]);
  return _SilentTokenRenew;
}(_react.Component);

(0, _defineProperty2.default)(_SilentTokenRenew, "propTypes", {
  setUserData: _propTypes.default.func.isRequired,
  handleFetchPermissions: _propTypes.default.func.isRequired
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setUserData: function setUserData(userData) {
      return dispatch((0, _actions.logIn)(userData));
    },
    handleFetchPermissions: function handleFetchPermissions() {
      return dispatch((0, _utils2.fetchPermissions)());
    }
  };
};

var SilentTokenRenew = (0, _reactRedux.connect)(null, mapDispatchToProps)(_SilentTokenRenew);
exports.SilentTokenRenew = SilentTokenRenew;
//# sourceMappingURL=silent-token-renew.js.map